module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.341872fa.svg";